import {Component, Input} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AREA_IMAGES, IMAGE_BASE_PATH } from '../../../constants/images.constants';

@Component({
  selector: 'areas-image-selector',
  templateUrl: './imageSelector.component.html',
  styleUrls: ['./imageSelector.component.less'],
})
export class AreasImageSelector  {

  public images: Array<string> = AREA_IMAGES;
  public basePath: string = IMAGE_BASE_PATH + 'areas/';
  @Input()
  public selectedImage: string;

  public constructor(public activeModal: NgbActiveModal) {}

  public selectImage(image) {
    this.selectedImage = image;
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/areas/form/imageSelector.component.ts